@if (!authorization()) {
  <router-outlet></router-outlet>
}

@if (debug) {
  <core-debug></core-debug>
}
